// extracted by mini-css-extract-plugin
export default {"container":"LNNJpd","squareImage":"OPs11j","wideImage":"dVx9_0"};